/* global Drupal, once */

/**
 * Keep the ADM navigation styling in sync with the scroll position.
 */
Drupal.behaviors.admnNavbar = {
  attach(context) {
    for (const navbar of once('admn-navbar', '.page > nav.navbar', context)) {
      const logo = navbar.querySelector('.site-logo');
      const siteAlert = document.querySelector('.page > .site-alert');
      const initiallyFixed = navbar.classList.contains('fixed-top');
      const initialBodyPadding = document.body.style.paddingTop;
      const collapse = navbar.querySelector('.navbar-collapse');

      const updateNavbar = () => {
        const scrolled = window.scrollY > (siteAlert?.offsetHeight ?? 0);

        navbar.classList.toggle('navbar-dark', !scrolled);
        navbar.classList.toggle('navbar-light', scrolled);
        navbar.classList.toggle('bg-primary', !scrolled);
        navbar.classList.toggle('bg-stripes', !scrolled);
        navbar.classList.toggle('bg-light', scrolled);
        navbar.classList.toggle('fixed-top', scrolled || initiallyFixed);
        navbar.setAttribute('data-bs-theme', scrolled ? 'light' : 'dark');

        if (logo) {
          const logoUrl = scrolled ? logo.dataset.siteLogoDark : logo.dataset.siteLogo;
          if (logoUrl) {
            logo.setAttribute('src', logoUrl);
          }
          logo.classList.toggle('logo-dark', scrolled);
          logo.classList.toggle('logo-light', !scrolled);
        }

        if (siteAlert) {
          siteAlert.style.visibility = scrolled ? 'hidden' : '';
        }
        document.body.style.paddingTop = scrolled ? `${navbar.offsetHeight}px` : initialBodyPadding;
      };

      collapse?.addEventListener('show.bs.collapse', () => navbar.classList.remove('navbar-closed'));
      collapse?.addEventListener('hidden.bs.collapse', () => navbar.classList.add('navbar-closed'));
      window.addEventListener('scroll', updateNavbar, { passive: true });
      window.addEventListener('resize', updateNavbar);
      updateNavbar();
    }
  },
};
